import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {Observable, Subject, takeUntil} from 'rxjs';
import {Customers} from '../../../account-info-header/models/AccountInfoApiResponse';
import {RadioControl} from '../../models/form/FormControlRadio';
import {createControl} from '../../utilities/formUtilities';
import {NamePipe} from '../../../shared/pipes/NamePipe';
import {Store} from '@ngrx/store';

@Component({
  standalone: false,
  selector: 'mm-ach-requesting-account-holder',
  templateUrl: './ach-requesting-account-holder.component.html',
  styleUrls: ['./ach-requesting-account-holder.component.scss']
})
export class AchRequestingAccountHolderComponent implements OnInit, OnDestroy {
  @Input() parentForm: UntypedFormGroup;
  @Input() customers$: Observable<Customers[] | null>;
  private readonly formControlName: string = 'requestingAccountHolderId';
  requestingAccountHolderModel: RadioControl = {
    title: 'Account holder requesting transaction',
    controlName: this.formControlName,
    radios: [],
    validationMessage: 'Select the account holder requesting the transaction',
  };
  destroy$ = new Subject<boolean>();

  constructor(private namePipe: NamePipe, private store: Store) {
  }

  ngOnInit(): void {
    createControl(this.parentForm, this.formControlName, '', [Validators.required]);

    this.customers$.pipe(
      takeUntil(this.destroy$),
    ).subscribe((customers) => {
      this.requestingAccountHolderModel.radios = customers?.map((customer) => {
        const isDpoa = customer.accountRoles?.includes('DPOA');
        const name = `${this.namePipe.transform(customer.firstName)} ${this.namePipe.transform(customer.lastName)}`;
        const label = [isDpoa ? `${name} (DPOA)` : name];
        return {
          value: customer.customerId,
          label
        }
      }) ?? [];
    })

    if (this.requestingAccountHolderModel.radios.length === 1) {
      this.requestingAccountHolderId?.patchValue(this.requestingAccountHolderModel.radios[0].value);
    }
  }

  ngOnDestroy(): void {
    this.parentForm.removeControl(this.formControlName);

    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

  get requestingAccountHolderId(): UntypedFormControl {
    return this.parentForm?.get(this.formControlName) as UntypedFormControl;
  }
}
